import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sqWorkbenchStore, sqWorkbookStore } from '@/core/core.stores';
import { useFlux } from '@/core/hooks/useFlux.hook';
import { WorksheetPreferencesModal } from '@/header/WorksheetPreferencesModal.molecule';
import { doResetLayout } from '@/main/layout.utilities';
import { isWorksheet } from '@/main/routing.utilities';
import { useLayoutLocked, useWorkbenchLayoutActions } from '@/main/workbenchLayout.store';
import { isViewOnlyWorkbookMode } from '@/utilities/workbookMode.utilities';
import { determineIsOwner } from '@/workbook/workbook.utilities';
import { Icon, TriggerWithDropdown } from '@seeqdev/qomponents';

export const LayoutControls = () => {
  const { t } = useTranslation();
  const { setLayoutLocked } = useWorkbenchLayoutActions();
  const [showWorksheetPreferencesModal, setShowWorksheetPreferencesModal] = useState(false);

  const layoutLocked = useLayoutLocked();
  const { isTopic, owner } = useFlux(sqWorkbookStore);
  const { currentUser } = useFlux(sqWorkbenchStore);

  const isWorksheetOrViewOnly = isWorksheet() || isViewOnlyWorkbookMode();
  const isOwner = determineIsOwner(owner, currentUser);
  const canSavePreferences = isWorksheetOrViewOnly && isOwner && !isTopic;

  const resetLayout = () => {
    setLayoutLocked(false);
    doResetLayout();
  };

  const actions = [
    {
      href: '#',
      icon: 'fa-window-restore',
      onClick: resetLayout,
      label: t('LAYOUT.RESET_LAYOUT'),
      testId: 'resetLayout',
    },
    {
      href: '#',
      icon: layoutLocked ? 'fa-lock-open' : 'fa-lock',
      label: layoutLocked ? t('LAYOUT.UNLOCK_LAYOUT') : t('LAYOUT.LOCK_LAYOUT'),
      onClick: () => {
        setLayoutLocked(!layoutLocked);
      },
      hasDivider: canSavePreferences,
      testId: 'lockLayout',
    },
    ...(canSavePreferences
      ? [
          {
            href: '#',
            icon: 'fa-sliders',
            label: t('USER.WORKSHEET_PREFERENCES'),
            onClick: () => setShowWorksheetPreferencesModal(true),
            testId: 'worksheetPreferences',
          },
        ]
      : []),
  ];

  return (
    <>
      <div
        className="flexColumnContainer cursorPointer tw:ml-sq-5 tw:flex-none tw:items-center"
        data-testid="layoutMenu">
        <TriggerWithDropdown
          tooltip={t('LAYOUT.CONFIGURE')}
          tooltipPlacement="bottom"
          dropdownItems={actions}
          triggerIcon={
            <Icon
              icon="fa-table-layout"
              iconPrefix="fa-regular"
              type="white"
              extraClassNames="fa-xlg flexNoGrowNoShrink mr5 sq-navbar-default"
            />
          }
        />
      </div>
      {showWorksheetPreferencesModal && (
        <WorksheetPreferencesModal onClose={() => setShowWorksheetPreferencesModal(false)} />
      )}
    </>
  );
};
